export default __webpack_public_path__ + "static/media/man.73fa7ee5.png";